import { render } from "./garment-behind-scenes.vue?vue&type=template&id=68395415&scoped=true"
import script from "./garment-behind-scenes.vue?vue&type=script&lang=js"
export * from "./garment-behind-scenes.vue?vue&type=script&lang=js"

import "./garment-behind-scenes.vue?vue&type=style&index=0&id=68395415&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68395415"]])

export default __exports__